import platform from '../../common/platform';
import yyb from './yyb';
import tv from './tv';
import gamer from './gamer';
import qb from './qb';
import news from './news';
import egame from './egame';
import tgclub from './tgclub';
import music from './music';
import wechat from './wx';
import lolapp from './lolapp';
import djc from './djc';

var getEnv = function getEnv() {
  if (platform.isWxApp()) {
    return 'wechat';
  }

  if (platform.isQQApp()) {
    return 'mqq';
  }

  if (platform.isLoLApp()) {
    return 'lolapp';
  }

  if (platform.isDJC()) {
    return 'djc';
  }

  if (platform.isYYB()) {
    return 'yyb';
  }

  if (platform.isTV()) {
    return 'tv';
  }

  if (platform.isGamer()) {
    return 'gamer';
  }

  if (platform.isNews()) {
    return 'news';
  }

  if (platform.isEGame()) {
    return 'egame';
  }

  if (platform.isTgClub()) {
    return 'tgclub';
  }

  if (platform.isMusic()) {
    return 'music';
  }

  if (platform.isQB()) {
    return 'qb';
  }

  return 'others';
};

export var getJsBridge = function getJsBridge() {
  if (getEnv() === 'wechat') {
    return wechat;
  }

  if (getEnv() === 'lolapp') {
    return lolapp;
  }

  if (getEnv() === 'djc') {
    return djc;
  }

  if (getEnv() === 'yyb') {
    return yyb;
  }

  if (getEnv() === 'tv') {
    return tv;
  }

  if (getEnv() === 'gamer') {
    return gamer;
  }

  if (getEnv() === 'news') {
    return news;
  }

  if (getEnv() === 'egame') {
    return egame;
  }

  if (getEnv() === 'tgclub') {
    return tgclub;
  }

  if (getEnv() === 'music') {
    return music;
  }

  if (getEnv() === 'qb') {
    return qb;
  } // TODO:非指定环境下增加默认函数，防止无定义报错


  return null;
};
export default {
  getJsBridge: getJsBridge,
  getEnv: getEnv
}; // export default class JsBridge {
//     constructor() {
//         this.appJsBridge = getJsBridge()
//     }
//     setAppCookie() {
//         if (this.appJsBridge) {
//             this.appJsBridge.setAppCookie()
//         }
//     }
//     loginByQQAndWX() {
//         if (this.appJsBridge) {
//             this.appJsBridge.loginByQQAndWX()
//         }
//     }
//     loginByWX() {
//         if (this.appJsBridge) {
//             this.appJsBridge.loginByWX()
//         }
//     }
//     loginByQQ() {
//         if (this.appJsBridge) {
//             this.appJsBridge.loginByQQ()
//         }
//     }
// }